<template>
  <div class="px-6 d-flex align-baseline">
    <span class="text-h6 font-weight-bold">{{ $t(sectionTitles[section]) }}</span>
    <select v-model="lang" class="text-medium-emphasis ml-auto mr-n1" style="background: transparent; border: none; padding: 2px 4px; outline: none">
      <option value="fr">FR</option>
      <option value="en">EN</option>
    </select>
  </div>
  <v-card class="mt-4 mx-6 pt-12 px-12 pb-4 flex-1-0 d-flex flex-column" v-bind="$attrs">
    <user-login v-if="section == 'login'" @navigate-section="navigateSection"></user-login>
    <user-register v-if="section == 'register'" @navigate-section="navigateSection"></user-register>
    <user-password-remind v-if="section == 'password-remind'" @navigate-section="navigateSection"></user-password-remind>
    <user-password-reset v-if="section == 'password-reset'" @navigate-section="navigateSection"></user-password-reset>
    <!-- SECTION SSO -->
    <div v-if="isLoading" class="py-6 text-center"><i class="far fa-spinner fa-spin fa-3x"></i></div>
    <div v-if="errorMessage" class="text-errorred" v-html="errorMessage"></div>
  </v-card>
</template>

<script>
  import clientConfig from '@/client_customs/config';
  import useLangStore from '@/stores/lang';
  import UserLogin from './UserLogin.vue';
  import UserRegister from './UserRegister.vue';
  import UserPasswordRemind from './UserPasswordRemind.vue';
  import UserPasswordReset from './UserPasswordReset.vue';
  // import PKCE from './PKCE';

  export default {
    components: {
      UserLogin,
      UserRegister,
      UserPasswordRemind,
      UserPasswordReset,
    },
    emits: ['navigate'],
    data() {
      return {
        section: clientConfig.sso ? 'sso' : 'login',
        sectionTitles: {
          login: 'LOGIN.TITLE',
          register: 'LOGIN.REGISTER_TITLE',
          'password-remind': 'LOGIN.REMIND_PASSWORD_TITLE',
          'password-reset': 'LOGIN.RESET_PASSWORD_TITLE',
          sso: 'Authentification',
        },
        isLoading: false,
        errorMessage: "",
        langStore: useLangStore(),
      };
    },
    computed: {
      lang: {
        get() {
          return this.langStore.lang;
        },
        set(newLang) {
          this.langStore.loadLang(newLang);
        },
      },
    },
    watch: {
      $route() {
        this.readQueryParams();
      },
    },
    created() {
      this.readQueryParams();
      if (clientConfig.sso) this.handleSSO();
    },
    methods: {
      readQueryParams() {
        if (this.$route.query.form == 'reset' && this.$route.query.token) {
          const query = { ...this.$route.query, resettoken: this.$route.query.token, form: undefined, token: undefined };
          this.$router.replace({ query });
        }
        if (this.$route.query.email) {
          const query = { ...this.$route.query, registeremail: this.$route.query.email, email: undefined };
          this.$router.replace({ query });
        }

        if (this.$route.query.resettoken) {
          this.navigateSection('password-reset');
        } else if (this.$route.query.registeremail) {
          this.navigateSection('register');
        }
      },
      navigateSection(section) {
        this.section = section;
      },
      handleSSO() {
        if (! clientConfig.sso) return;
        this.isLoading = true;
        const responseType = clientConfig.sso.response_type || 'ticket';
        let responseData = window.location.search.match(new RegExp(`${responseType}=([^&]*)`));
        if (! responseData) responseData = window.location.hash.match(new RegExp(`${responseType}=([^&]*)`));
        if (responseData) {
          if (window.history) window.history.replaceState(null, null, './');

          // if (clientConfig.sso.protocol == 'PKCE') {
          //   PKCE.validate(responseData[1]).then((message) => {
          //     // TO DO
          //     this.errorMessage = message;
          //   }).catch((error) => {
          //     this.errorMessage = `Erreur : ${error}`;
          //   }).finally(() => { this.isLoading = false; });
          //   return;
          // }

          const ssoRedirect = window.sessionStorageWrapper.getItem('sso_redirect');
          window.apiSrv.ssoLogin({
            protocol: clientConfig.sso.protocol,
            [responseType]: responseData[1],
            allow_sso_anonymous: /#\/(viewer|planningview)\/.*\?(view)?rotoken=/i.test(ssoRedirect) || undefined,
          }).then(() => {
            if (ssoRedirect) {
              window.location.replace(ssoRedirect);
              window.sessionStorageWrapper.removeItem('sso_redirect');
            }
            window.location.reload();
          }).catch((error) => {
            this.isLoading = false;
            this.errorMessage = 'Erreur : ';
            if (typeof error == 'object') {
              this.errorMessage += Object.keys(error).map((key) => {
                const messages = error[key];
                if (Array.isArray(messages)) return `- ${messages.join('\n- ')}`;
                return messages;
              }).join("\n");
            } else {
              this.errorMessage += error || "";
            }
          });
        } else {
          window.sessionStorageWrapper.setItem('sso_redirect', window.location.href);
          // if (clientConfig.sso.protocol == 'PKCE') {
          //   PKCE.login();
          //   return;
          // }
          window.location.href = clientConfig.sso.login;
        }
      },
    },
  };
</script>
